import { CersDecisionStatus, StaffCersSubmittalsQuery } from "generated-graphql/graphql";

/**
 * Builds the same-grid "facility timeline" URL: the CERS submittals route scoped
 * to one facility via the `facility` omnisearch keyed term the V2 grid reads from
 * the `omnisearch` URL param. Default sort is submittedDate DESC, giving a
 * reverse-chronological "timeline" for free. Inner double quotes are stripped so
 * they can't terminate the quoted term early.
 */
export function facilityTimelineUrl(facilityName: string): string {
  const omnisearch = `facility:"${facilityName.replace(/"/g, "")}"`;
  return `/staff/cers/submittals?omnisearch=${encodeURIComponent(omnisearch)}`;
}

/** UTC date like "Jun 24, 2025"; "—" when missing. Shared by the CERS drawers. */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
}

/** A single CERS submittal row as returned by the staff submittals query. */
export type CersSubmittalRow = StaffCersSubmittalsQuery["staffCersSubmittals"]["items"][number];

/**
 * Color map for CersDecisionStatus chips:
 * Accepted=success, NotAccepted=error, UnderReview/Submitted=info,
 * Certified/NotApplicable=default
 */
export function decisionStatusColor(
  status: CersDecisionStatus
): "success" | "error" | "info" | "default" {
  switch (status) {
    case CersDecisionStatus.Accepted:
      return "success";
    case CersDecisionStatus.NotAccepted:
      return "error";
    case CersDecisionStatus.UnderReview:
    case CersDecisionStatus.Submitted:
      return "info";
    default:
      return "default";
  }
}
